import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import Header from './composant/Header';
// import Footer from './components/Footer.jsx';
import Router from './Router';



const AppContent = () => {
  const location = useLocation();
  const isPublicTrackingPage = location.pathname.startsWith('/s/');

  return (
    <>
      {!isPublicTrackingPage && <Header />}

      <main>
        <Router />
      </main>
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;
